export const queryKeys = {
  me: ["auth", "me"] as const,
  dashboard: ["dashboard"] as const,
  resource: (key: string, search: string) => ["resource", key, search] as const,
  settings: ["settings"] as const,
};
